import { render, staticRenderFns } from "./FiIcon.vue?vue&type=template&id=74581cb4&scoped=true&lang=pug&"
import script from "./FiIcon.vue?vue&type=script&lang=js&"
export * from "./FiIcon.vue?vue&type=script&lang=js&"
import style0 from "./FiIcon.vue?vue&type=style&index=0&id=74581cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74581cb4",
  null
  
)

export default component.exports